<!-- 
Dialog for disabling a user's multi-factor authentication.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog md">
    <v-form ref="form">
      <v-card>
        <v-toolbar color="secondary" flat dark>
          <v-toolbar-title>Switch to email multi-factor authentication</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <our-loading-indicator v-if="loading"/>
        <v-card-text v-else>
          <v-container grid-list-md pa-0>
            <v-layout wrap>
              <v-alert :value="true" type="info">You must verify the identity of the requesting user before removing authenticator and switching to email multi-factor authentication.</v-alert>            
            </v-layout>

            <v-layout wrap>
              <our-data-field label="Email address" label-width="12" offset="0">{{ emailAddress }}</our-data-field>

              <v-flex xs12>
                <v-checkbox
                  v-model="message.verified"
                  label="Verified"
                  :rules="[rules.required]"
                >
                </v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-textarea 
                    v-model="message.reason"
                    :rules="[rules.required]"
                    label="Reason" autocomplete="off"
                    required
                  />
              </v-flex>
            </v-layout>
          </v-container>
          <our-required-field-indicator/>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :disabled="busy" flat @click.native="hide">Cancel</v-btn>
          <v-btn
            v-if="!loading"
            ref="save-button"
            :disabled="busy" 
            flat color="success" 
            type="submit" 
            @click.prevent="save"
          >Switch</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <our-validation-dialog v-model="showValidationDialog" :form="this.$refs.form" :state-error="state.error" />
  </v-dialog>
</template>

<script>
import * as action from "@/store/prisms-users/action-types";
import lookupMixins from "@/mixins/lookup.mixins";
import ruleMixins from "@/mixins/rule.mixins";
import axios from "axios";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";
import { deepCopyAxiosException } from "@/store/helpers";

export default {
  mixins: [lookupMixins, ruleMixins],
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    userId: {
      type: Number,
      default: null
    }
  },
  data() {    
    return {
      showValidationDialog: false,
      emailAddress: "",
      loading: false,
      message: {
        verified: null,
        reason: null
      },
    };
  },
  computed: {
    state() {
      return this.$store.state.prismsUsers.updateUserMfa;
    },
    busy() {
      return this.state.saving || this.loading;
    }
  },
  watch: {
    show(nowShowing) {
      if (nowShowing) {
        this.load();
      }
      else {
        this.reset();
      }
    }
  },
  methods: {
    async load() {
      try {
        this.loading = true;
        var result = await axios.get(`/api/users/${this.userId}/switch-to-email-mfa`)
        this.emailAddress = result.data.emailAddress;
        this.loading = false;
      } catch (e) {
        this.$store.commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      }
    },
    async save() {
      if (this.$refs.form.validate() && (await this.$store.dispatch(action.SWITCH_TO_EMAIL_MFA, { userId: this.userId, verified: this.message.verified, reason: this.message.reason }))) {
        this.hide();
        this.$emit("save");
      } else {
        this.showValidationDialog = true;
      }
    },
    hide() {
      this.$emit("update:show", false);
    },
    reset() {
      this.message.reason = null;
      this.message.verified = null;
      this.emailAddress = "";
      this.showValidationDialog = false;
    }
  }
};
</script>
